module.exports = __webpack_public_path__ + "img/ocean-white.9136cbcd.svg";